<template>
  <div class="address-details">
    <!-- Address Details -->
    <h6 class="sub-header primary-color">{{ getText("BillingAddress") }}</h6>

    <div class="row">
      <div class="col-sm-6">
        <FormInput
          :title="getText('FullName')"
          placeholder="John Smith"
          autocomplete="name"
          v-model="billing_details.Name"
        />
      </div>

      <div class="col-sm-6">
        <FormInput
          :title="getText('EmailAddress')"
          prefix="@"
          placeholder="your.name@email.com"
          autocomplete="email"
          v-model="billing_details.Email"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <FormInput
          :title="getText('Address')"
          placeholder="1234 Reach Rd."
          autocomplete="street-address"
          v-model="billing_details.Address"
        />
      </div>

      <div class="col-sm-6">
        <FormInput
          :title="getText('City')"
          placeholder="Calgary"
          autocomplete="locality"
          v-model="billing_details.City"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <FormInput
          :title="getText('Region')"
          placeholder="AB"
          v-model="billing_details.Region"
          autocomplete="region"
          v-if="region_list.length == 0"
        />
        <FormSelect
          :title="getText('Region')"
          :options="region_list"
          v-if="region_list.length > 0"
          :default_text="getText('SelectRegion')"
          autocomplete="region"
          v-model="billing_details.Region"
        />
      </div>

      <div class="col-sm-6">
        <FormSelect
          :title="getText('Country')"
          :options="country_options"
          :default_text="getText('SelectCountry')"
          default_disabled="true"
          autocomplete="Country"
          v-model="billing_details.Country"
          @change="resetRegion"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <FormInput
          :title="getText('PostalCode')"
          placeholder="90210"
          autocomplete="postal-code"
          v-model="billing_details.PostalCode"
        />
      </div>

      <div class="col-sm-6">
        <FormInput
          :title="getText('PhoneNumber')"
          prefix="#"
          placeholder="(750)123-1234"
          autocomplete="tel"
          v-model="billing_details.Phone"
        />
      </div>
    </div>

    <br v-if="requireNationalID || requireDOB" />
    <div class="row" v-if="requireNationalID || requireDOB">
      <div class="col-sm-6" v-if="requireNationalID">
        <FormInput
          :title="getText('NationalIdentifier')"
          placeholder="123..."
          v-model="billing_details.NationalIdentifier"
        />
      </div>

      <div class="col-sm-6" v-if="requireDOB">
        <FormDatePicker
          :title="getText('BirthDate')"
          placeholder="YYYY-MM-DD"
          v-model="billing_details.BirthDate"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";

// Language / Localization
import LanguageService from "@/common/language.service";

import { SET_BILLING_INFO } from "@/store/mutations.type";

import {
  NATIONAL_IDENTIFIER_COUNTRIES,
  BIRTH_DATE_COUNTRIES,
  COUNTRY_REGIONS,
} from "@/config/country.config";

import FormInput from "@/components/form_elements/FormInput";
import FormSelect from "@/components/form_elements/FormSelect";
import FormDatePicker from "@/components/form_elements/FormDatePicker";

export default {
  name: "AddressDetails",
  components: {
    FormInput,
    FormSelect,
    FormDatePicker,
  },
  data() {
    return {};
  },
  beforeMount() {
    // If we have a specific region list for this country, preset data
    if (this.region_list.length > 0) this.Region = this.region_list[0].id;
  },
  watch: {
    // update store on user input
    billing_details: {
      handler: function(billing) {
        store.commit(SET_BILLING_INFO, billing);
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["countries", "billing", "country_options"]),
    billing_details: {
      get: function() {
        return this.billing;
      },
      set: function() {
        // do nothing
        // the object value is captured by thw watch, which can handle deep
        // mutations, but the setter method still needs to be defined
      },
    },
    country_name() {
      return this.countries.filter(
        (x) => x.code == this.billing_details.Country
      )[0].name;
    },
    region_list() {
      const regions = COUNTRY_REGIONS[this.billing_details.Country];
      if (!Array.isArray(regions)) return [];
      return regions.map((x) => ({ id: x.code, value: x.name }));
    },
    requireNationalID() {
      return NATIONAL_IDENTIFIER_COUNTRIES.includes(
        this.billing_details.Country
      );
    },
    requireDOB() {
      return BIRTH_DATE_COUNTRIES.includes(this.billing_details.Country);
    },
  },
  methods: {
    getText(key) {
      return LanguageService.getText(key);
    },
    resetRegion($event) {
      this.billing_details.Region = "";
    },
  },
};
</script>
